import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=054ffaca&"
import script from "./SocialMedia.vue?vue&type=script&lang=js&"
export * from "./SocialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054ffaca')) {
      api.createRecord('054ffaca', component.options)
    } else {
      api.reload('054ffaca', component.options)
    }
    module.hot.accept("./SocialMedia.vue?vue&type=template&id=054ffaca&", function () {
      api.rerender('054ffaca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/SocialMedia.vue"
export default component.exports